<template>
  <b-modal ref="editResultModal" title="Bearbeiten">
    <b-form>
      <b-form-group label="Name">
        <b-form-input name="name" v-model="name"></b-form-input>
      </b-form-group>

      <b-form-group v-if="this.age != null" label="Klassenstufe">
        <b-form-select name="name" v-model="age" :options="ageOptions[this.age]"></b-form-select>
      </b-form-group>
    </b-form>

    <template slot="modal-footer">
      <b-btn class="mt-3" variant="danger" block @click="save">Speichern</b-btn>
      <b-btn class="mt-3" variant="secondary" block @click="hide">Abbrechen</b-btn>
    </template>
  </b-modal>
</template>
<script>
export default {
  name: 'EditResultModal',

  data: function () {
    return {
      token: null,
      name: '',
      age: null,
      ageOptions: {
        3: [3, 4],
        4: [3, 4],
        5: [5, 6],
        6: [5, 6],
        7: [7, 8],
        8: [7, 8]
      }
    }
  },

  methods: {
    show: function (token, name, age) {
      this.token = token
      this.name = name
      this.age = age

      this.$refs.editResultModal.show()
    },

    hide: function () {
      this.$refs.editResultModal.hide()
    },

    save: function () {
      let data = {
        name: this.name
      }

      if (this.age != null) {
        data.age = this.age
      }

      this.axios.patch('/quiz/results/' + this.token, JSON.stringify(data))
        .then((rsp) => {
          this.$emit('editName', this.token, rsp.data)
          this.$refs.editResultModal.hide()
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/results/EditResultModal.vue